/**
 * 回车转换，元素聚焦指令
 * author：lilw
 * version:1.5.2.1
 * 1.5.2   ------ 调增回车换行的整体调整
 * 1.5.2.1 ------ 添加对vendor组件的应对
 */
export default {
  bind:function(el, binding, vnode){
    var jumpArr = [];
    el.onkeydown=function(ev){
      if(ev.keyCode===13){
        ev.stopPropagation()
        ev.preventDefault()
        // 下一个元素聚焦处理
        if(binding.modifiers!=null && binding.modifiers!==undefined){
            var modifiers = binding.modifiers;
            for(var key in modifiers){
                jumpArr.push(key);
            }
        }
        var _arg = isJump(binding.arg)
        var nextInput = vnode.context.$refs[_arg]
        var localRef = vnode.data.ref;
        var localInput = vnode.context.$refs[localRef];
        if (nextInput.$el.className.indexOf("my-el-input") !== -1) {
          // nextInput = nextInput.$refs[binding.arg];
        }
        var nel = nextInput.$el
        var fClass = nel.getAttribute("class").split(" ")[0]
        if(localInput.$el.className.indexOf("el-select") !== -1){
          localInput.blur();
        }
        if(localInput.$el.className.indexOf("el-date-editor") !== -1){
          localInput.hidePicker();
        }
        switch (fClass) {
          case "my-el-input":
              nextInput.setFocus();
              break;
          case "el-input":
          case "el-date-editor":
          case "el-select":
            nextInput.focus()
            break;
          case "el-checkbox":
          case "el-radio":
          case "el-button":
            nel.focus()
            break;
        }
      } else if(ev.keyCode===32){
          var localRef = vnode.data.ref;
          var localInput = vnode.context.$refs[localRef];
          var fClass = localInput.$el.getAttribute("class").split(" ")[0];
          switch (fClass) {
              case "el-input":
              case "my-el-input":
              case "el-date-editor":
              case "el-select":
                  localInput.change();
                  break;
              case "el-checkbox":
              case "el-radio":
                  localInput.$el.click()
                  break;
          }
      }
    }

    var isJump = (function f(arg){
      var el = vnode.context.$refs[arg];
      if(el === undefined){
          if(jumpArr.length > 0){
              if(jumpArr.indexOf(arg) > -1){
                var index = jumpArr.indexOf(arg);
                return f(jumpArr[index+1]);
              } else {
                return f(jumpArr[0]);
              }
          } else {
              return arg;
          }
      }
      var input = el.$el.getElementsByTagName("input")[0];
      if(input!==undefined){
          var isDisplay = input.getAttribute("type")
          var isDisabled = input.getAttribute("disabled")
          if(isDisplay == "hidden" || isDisabled == "disabled"){
              var _arg = vnode.context.$refs[arg].$vnode.data.directives[0].arg
              return f(_arg)
          } else {
              return arg;
          }
      } else {
          return arg;
      }

    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/modules/next-ele.js